import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateComponent } from './create/create.component';
import { ListComponent } from './list/list.component';
import { EditComponent } from './edit/edit.component';


const routes: Routes = [
  {path:'',component:CreateComponent, data: { title: 'إضافة سؤال جديد' }},
  {path:'create',component:CreateComponent, data: { title: 'إضافة سؤال جديد' }},
  {path:'list',component:ListComponent, data: { title: 'عرض الأسئلة' }},
  {path:'update/:faq_id',component:EditComponent, data: { title: 'تعديل سؤال ' }},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FaqRoutingModule { }
